import { LademittelModel } from '../../../../models/LademittelModel';
import { EigentuemerModel } from '../../../../models/EigentuemerModel';
import { TableConfig } from '../../../../components/table/Table';
import { toSelectOptions } from '../../../../components/select/SelectModel';

export const initzusLademittelTableConfig = (
  lademittel?: LademittelModel[],
  eigentuemer?: EigentuemerModel[]
): TableConfig => {
  return [
    {
      id: 1,
      columnName: 'Nr.',
      attributName: 'anzFolge',
      valueType: 'button',
    },
    {
      id: 2,
      columnName: 'Anzahl',
      attributName: 'anzahl',
      valueType: 'number',
    },
    {
      id: 3,
      columnName: 'Lademittel',
      attributName: 'lademittel',
      valueType: 'select',
      selectData: toSelectOptions(lademittel, 'kurzBezeichnung'),
    },
    {
      id: 4,
      columnName: 'Eigentümer',
      attributName: 'eigentuemer',
      valueType: 'select',
      selectData: toSelectOptions(eigentuemer, 'name'),
    },
  ];
};
